
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`The legacy SEEK ANZ advertiser ID.`}</p>
    <p>{`This is a numeric identifier used by legacy Job Posting & Application Export APIs in the `}<inlineCode parentName="p">{`seekAnz`}</inlineCode>{` scheme.
For organizations in other schemes this will be `}<inlineCode parentName="p">{`null`}</inlineCode>{`.`}</p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;